module.exports = __webpack_public_path__ + "static/img/bg__signup.0cddb10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg__signup.png
// module id = ERad
// module chunks = 1